export const sumArray = (array) => {
  return array.reduce((accumulator, currentValue) => {
    return accumulator + currentValue;
  }, 0);
};

export const slugify = (str) => {
  return String(str)
    .toLowerCase()
    .normalize('NFKD') // split accented characters into their base characters and diacritical marks
    .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
    .replace('ð', 'd')
    .replace('ø', 'o')
    .trim() // trim leading or trailing whitespace
    .toLowerCase() // convert to lowercase
    .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/-+/g, '-'); // remove consecutive hyphens
};

export const shortenTeamName = (teamName) => {
  const targetTeamNames = [
    {
      name: 'IF Brommapojkarna',
      replacement: 'IFBP',
    },
  ];

  if (!targetTeamNames.find((item) => item.name === teamName)) return teamName;

  return targetTeamNames.find((item) => item.name === teamName).replacement;
};

export const textExcerpt = (str, maxLen = 200, separator = ' ') => {
  if (str.length <= maxLen) return str;
  return `${str.substr(0, str.lastIndexOf(separator, maxLen))} [...]`;
};

export const filterStandings = (data) => {
  return Object.values(data).filter((i) => i.name);
};

export const addRankingNumberWithDuplicates = (sortedPlayers, stat) => {
  let value;
  let ranking;

  return sortedPlayers.map((x, i) => {
    if (value !== x[stat]) {
      value = x[stat];
      ranking = i + 1;
    }

    return {
      ...x,
      ranking,
    };
  });
};

export const sortStandings = (data, key, direction) => {
  if (key === 'pts' && direction === 'desc') {
    return data;
  }

  // Sort first by stats value or fall back to position based on sort direction
  const sorted = Object.values(data)
    .filter((d) => !!d.teamId)
    .sort((a, b) => {
      const aValue = parseInt(
        a.stats?.find((i) => i.name === key)?.value || '0',
        10
      );
      const bValue = parseInt(
        b.stats?.find((i) => i.name === key)?.value || '0',
        10
      );
      const aPosition = a.position;
      const bPosition = b.position;

      if (aValue > bValue) return direction === 'asc' ? 1 : -1;
      if (aValue < bValue) return direction === 'asc' ? -1 : 1;
      return direction === 'asc'
        ? bPosition - aPosition
        : aPosition - bPosition;
    });

  const sortedData = {};
  sorted.forEach((item, index) => {
    const teamItem = { ...item };
    teamItem.position = index + 1;
    teamItem.previousPosition = null;
    teamItem.borderType = data[teamItem.position]?.borderType || 'noborder';
    sortedData[index + 1 + ''] = teamItem;
  });
  return sortedData;
};
